import { Record } from 'immutable'

export interface IContactEmailAddress {
  readonly address: string
  readonly contactId: string
  readonly displayName: string
}

const ContactEmailAddressRecord = Record({
  address: '',
  contactId: '',
  displayName: '',
})

export class ContactEmailAddress extends ContactEmailAddressRecord
  implements IContactEmailAddress {
  public static fromJS(initialState?: Partial<IContactEmailAddress>) {
    return new ContactEmailAddress(initialState)
  }

  public readonly address: string
  public readonly contactId: string
  public readonly displayName: string

  constructor(props?: Partial<ContactEmailAddress>) {
    props ? super(props) : super()
  }
}
